import React, { useEffect, useState } from 'react';
import { selectTranslations } from '../../../config/i18n/slice';
import { useSelector } from 'react-redux';
import { Dimmer, Loader } from 'semantic-ui-react';
import { BillingInfoIcon } from '../../../../Assets/Icons/svg';
import { Country, State } from 'country-state-city';

const Customers = ({ targetedData }) => {
  const t = useSelector(selectTranslations);

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return 'en';
    }
  });

  const [fetching, setFetchLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setFetchLoading(true);
    if (targetedData) {
      setData(targetedData);
      setFetchLoading(false);
    }
  }, [targetedData]);

  return (
    <div className="preview-details-wrapper">
      {fetching ? (
        <Dimmer active inverted>
          <Loader inverted>{t.common.loading}</Loader>
        </Dimmer>
      ) : (
        <>
          <div className="intro">
            <div
            //  style={{ marginTop: '-8px' }} 
             className="billing-info d-flex">
              <BillingInfoIcon />
              <p
              
                className={`font16 required-text mt-1 ${selectedLanguage == "en" ? "ml-2" : "mr-2"}`}
              >
                {t.customers.form.billing_information}
              </p>
            </div>
          </div>

          <div className="details-wrapper">
            <div className="d-flex align-items-center mt-7">
              <label className="workorder-intro-label customer-label1">
                {t.customers.form.name}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.name ? targetedData?.name : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label customer-label1">
                {t.locations.table.country}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.country
                  ? Country.getCountryByCode(targetedData?.country)?.name
                  : t.common.na}
              </p>
            </div>

          
            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label customer-label1">
                {t.locations.table.city}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.city
                  ? State.getStateByCodeAndCountry(
                      targetedData?.city,
                      targetedData?.country
                    )?.name
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label customer-label1">
                {t.customers.form.postal_code}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.postalCode
                  ? targetedData?.postalCode
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label customer-label1">
                {t.customers.form.address}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.address ? targetedData?.address : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label customer-label1">
                {t.customers.form.address_line_2}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.addressLine2
                  ? targetedData?.addressLine2
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label customer-label1">
                {t.customers.form.address_line_3}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.addressLine3
                  ? targetedData?.addressLine3
                  : t.common.na}
               
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="workorder-intro-label customer-label1">
                {t.customers.form.rate}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.rate
                  ? targetedData?.rate +
                    ' ' +
                    (targetedData?.currency ? targetedData?.currency : '')
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5 ">
              <label className="workorder-intro-label customer-label1">
                {t.customers.form.currency}
                {':'}
              </label>
              <p className="workorder-intro-value">
                {targetedData?.currency ? targetedData?.currency : t.common.na}
              </p>
            </div>

         
          </div>

         
        </>
      )}
    </div>
  );
};

export default Customers;
